import SideMenuWrapper from './SideMenuWrapper';

export default SideMenuWrapper;
